(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-callouts"] && !Shopify.designMode) return;
  try {
    
  const calloutRoots = document.querySelectorAll('.product-callouts [data-callouts]');

  calloutRoots.forEach((root) => {
    if (root.dataset.calloutsReady === 'true') return;
    root.dataset.calloutsReady = 'true';

    const overlayImages = root.querySelectorAll('.product-callouts__overlay-image');
    const prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!overlayImages.length) return;

    const readyClass = 'product-callouts--overlay-ready';
    const markReady = () => {
      root.closest('.product-callouts')?.classList.add(readyClass);
    };

    overlayImages.forEach((overlayImage) => {
      if (overlayImage.complete) {
        markReady();
      } else {
        overlayImage.addEventListener('load', markReady, { once: true });
      }
    });

    let tiltRaf = null;

    const updateTilt = (event) => {
      const rect = root.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      const maxTilt = 2;
      overlayImages.forEach((overlayImage) => {
        overlayImage.style.setProperty('--tilt-x', `${x * maxTilt}deg`);
        overlayImage.style.setProperty('--tilt-y', `${-y * maxTilt}deg`);
      });
    };

    if (!prefersReducedMotion) {
      root.addEventListener('pointermove', (event) => {
        if (tiltRaf) cancelAnimationFrame(tiltRaf);
        tiltRaf = requestAnimationFrame(() => updateTilt(event));
      });
    }

    root.addEventListener('pointerleave', () => {
      if (tiltRaf) cancelAnimationFrame(tiltRaf);
      overlayImages.forEach((overlayImage) => {
        overlayImage.style.setProperty('--tilt-x', '0deg');
        overlayImage.style.setProperty('--tilt-y', '0deg');
      });
    });

    if (!prefersReducedMotion) {
      let driftRaf = null;
      const maxDrift = 6;
      const updateDrift = () => {
        const rect = root.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
        const drift = (progress - 0.5) * maxDrift;
        overlayImages.forEach((overlayImage) => {
          overlayImage.style.setProperty('--drift-y', `${drift}px`);
          overlayImage.style.setProperty('--drift-x', `${drift * 0.5}px`);
        });
      };

      const scheduleDrift = () => {
        if (driftRaf) cancelAnimationFrame(driftRaf);
        driftRaf = requestAnimationFrame(updateDrift);
      };

      window.addEventListener('scroll', scheduleDrift, { passive: true });
      window.addEventListener('resize', scheduleDrift);
      scheduleDrift();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
